/* Afnan Shop & Win — draw qualification bar + entry popup.

   Modelled on the Gift Adder's approach, for the same reason: Prestige
   replaces the cart drawer's markup on every cart change, so the bar is
   INJECTED by JS and put back by a MutationObserver rather than rendered
   into the drawer from Liquid, which the first add-to-cart would wipe. */
(function () {
  'use strict';

  var ROOT = document.getElementById('asw-db-root');
  if (!ROOT) return;

  var COPY = JSON.parse(document.getElementById('asw-db-copy').textContent);
  var modal = document.getElementById('asw-db-modal');
  var cartPageHost = document.getElementById('asw-db-cartpage');

  var d = ROOT.dataset;
  var THRESHOLD = parseFloat(d.threshold) || 0;
  var WANT_POPUP = d.popup === '1' && !!modal;
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var currency = d.currency || 'AED';
  var total = parseInt(d.total, 10);
  if (isNaN(total)) total = 0;
  var qualified = false;

  var PLANE = '<svg viewBox="0 0 38 38" fill="none" aria-hidden="true"><path d="M35.944 26.5262L31.8449 16.2322L30.9203 13.9515C30.797 13.5817 30.9049 13.0423 31.1822 12.7649L35.8978 8.04942C37.3771 6.57004 38.0398 3.71916 37.3925 1.71584C37.1614 1.02238 36.6066 0.467618 35.9132 0.236465C33.9253 -0.395352 31.059 0.282694 29.5796 1.76207L24.8641 6.47758C24.5867 6.75497 24.0473 6.86284 23.6775 6.73956L11.1182 1.73125C9.7467 1.16108 7.74338 1.59256 6.69549 2.64045L4.66134 4.67459C3.35148 5.98446 3.6905 7.61794 5.43185 8.31139L16.4809 12.7033C17.3439 13.0423 17.5134 13.8591 16.8508 14.5217L15.1403 16.2322L12.3664 19.0061C12.012 19.3605 11.3031 19.6687 10.81 19.6687L3.64427 19.6841C2.90458 19.6841 2.01079 20.2389 1.65636 20.9323L0.254035 23.7216C-0.377782 24.9081 0.223214 26.3721 1.50226 26.7882L8.25191 27.3738C9.2844 27.4508 10.1936 28.36 10.2706 29.3925L10.8562 36.1422C11.2877 37.4058 12.7363 38.0222 13.9537 37.4212L16.7429 36.0189C17.421 35.6799 17.9911 34.7707 17.9911 34.031L18.0066 26.8652C17.9911 26.3567 18.2993 25.6478 18.6538 25.2934L23.1381 20.809C23.8008 20.1464 24.5867 20.3159 24.9565 21.1789L29.3484 32.228C30.0419 33.9693 31.6754 34.3084 32.9852 32.9985L35.0194 30.9643C36.0673 29.9165 36.4988 27.9131 35.944 26.5262Z" fill="currentColor"/></svg>';

  var MARKUP =
    '<div class="asw-db-airmail"></div>' +
    '<div class="asw-db-row">' +
      '<span class="asw-db-plane" aria-hidden="true">' + PLANE + '</span>' +
      '<p class="asw-db-msg"></p>' +
      '<span class="asw-db-stamp" aria-hidden="true"></span>' +
    '</div>' +
    '<div class="asw-db-track"><span class="asw-db-fill"></span></div>';

  /* ---------- money ----------
     Not every currency is hundredths: KWD, BHD and OMR are three-decimal,
     and all three are participating markets, so a hard-coded /100 would
     misread those carts by a factor of ten. Intl knows the right answer. */
     function decimals() {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency })
        .resolvedOptions().maximumFractionDigits;
    } catch (e) { return 2; }
  }
  /* Shopify money fields (cart.total_price included) are always expressed in
     HUNDREDTHS of the major unit, regardless of the ISO currency's real
     decimal precision — three-decimal currencies (BHD, KWD, OMR) are NOT the
     exception here even though Intl reports 3 fraction digits for them.
     decimals() above is for display formatting only; the storage factor is
     always 100. */
  function factor() { return 100; }
  function money(minor) {
    var dg = decimals(), v = minor / factor();
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency,
        minimumFractionDigits: dg, maximumFractionDigits: dg
      }).format(v);
    } catch (e) { return currency + ' ' + v.toFixed(dg); }
  }

  /* ---------- drawer ---------- */
  function drawerEl() { return document.querySelector('#cart-drawer, cart-drawer'); }

  /* ---------- paint ---------- */
  function paint(bar, animate) {
    var fill = bar.querySelector('.asw-db-fill');
    var msg = bar.querySelector('.asw-db-msg');
    var stampEl = bar.querySelector('.asw-db-stamp');
    /* A wrap that exists but is missing a piece of its own markup (see the
       note on injectDrawer below) must not throw here - one bad bar killing
       the whole paintAll() loop would leave every OTHER bar (the cart-page
       one included) stuck showing stale numbers too. */
    if (!fill || !msg || !stampEl) return false;

    var goal = THRESHOLD * factor();
    if (goal <= 0) return false;
    var ok = total >= goal;
    var pct = Math.max(0, Math.min(100, (total / goal) * 100));

    fill.style.width = pct + '%';
    if (ok) {
      msg.textContent = COPY.qualified;
    } else {
      /* Ceiling the shortfall: at 499.60 of 500 the remainder is 0.40, and a
         nearest-rounded "add 0.00 more" is unactionable nonsense. */
      var short = Math.ceil(goal - total);
      msg.innerHTML = String(COPY.below).replace('{amount}', '<b>' + money(short) + '</b>');
    }
    stampEl.textContent = COPY.stamp;
    bar.classList.toggle('is-ok', ok);
    if (ok) {
      if (animate) requestAnimationFrame(function () { bar.classList.add('is-stamped'); });
      else bar.classList.add('is-stamped');
    } else {
      bar.classList.remove('is-stamped');
    }
    bar.style.display = (total > 0 || ok) ? 'block' : 'none';
    return ok;
  }

  function paintAll(animate) {
    var ok = false, bars = document.querySelectorAll('.asw-db-wrap');
    for (var i = 0; i < bars.length; i++) { if (paint(bars[i], animate)) ok = true; }
    return ok;
  }

  /* ---------- inject into the drawer ----------
     Immediately before the line items, where the free-shipping bar and the
     goal bar already sit, so the three read as one stack. */
  function injectDrawer(animate) {
    var drawer = drawerEl();
    if (!drawer || drawer.querySelector('.asw-db-wrap')) return;

    var bar = document.createElement('div');
    bar.className = 'asw-db-wrap';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML = MARKUP;

    var items = drawer.querySelector('.cart-drawer__items');
    if (items && items.parentNode) items.parentNode.insertBefore(bar, items);
    else drawer.appendChild(bar);

    paint(bar, animate);
  }

  /* ---------- popup ----------
     Deliberately plain: show it, hide it, and keep its own clicks to
     itself. The single non-obvious line is the stopPropagation loop, and
     the comment there says why it has to exist. */
  function maybeCelebrate(was, now) {
    if (WANT_POPUP && now && !was) openModal();
  }

  function openModal() {
    modal.style.display = 'flex';
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    var btn = document.getElementById('asw-db-dismiss');
    if (btn) btn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    setTimeout(function () { modal.style.display = 'none'; }, REDUCE ? 0 : 300);
  }

  if (modal) {
    /* The popup sits outside <cart-drawer> in the DOM, so without this its
       events reach document - where the drawer's own click-outside-to-close
       handler sees them as a click outside itself and shuts the drawer.
       All three are bubble-phase, so the buttons below still get their
       events first; only the trip onward to document is cut. */
    ['pointerdown', 'mousedown', 'click'].forEach(function (evt) {
      modal.addEventListener(evt, function (e) { e.stopPropagation(); });
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('#asw-db-dismiss, #asw-db-close')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      /* Capture, because the drawer's Escape handler is on document too -
         the same node - and stopPropagation cannot stop a listener sharing
         a node with you. Running first in capture does stop it. */
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        e.stopPropagation();
        closeModal();
      }
    }, true);
  }

  /* ---------- apply a fresh cart ---------- */
  function apply(cart) {
    var was = qualified;
    total = cart.total_price;
    if (cart.currency) currency = cart.currency;
    injectDrawer(true);
    qualified = paintAll(true);
    maybeCelebrate(was, qualified);
  }

  /* ---------- cart change detection ----------
     No single event covers every theme, so the requests are watched too.
     Both primitives are WRAPPED, never replaced: the original is always
     called and its return value handed straight back, so a theme that
     inspects the response, or an error path, behaves exactly as before. */
  var CART_RE = /\/cart\/(add|change|update|clear)/i;
  var _fetch = window.fetch;

  if (typeof _fetch === 'function') {
    window.fetch = function () {
      var out = _fetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = typeof a === 'string' ? a : (a && a.url) || '';
        if (CART_RE.test(url) && out && out.then) {
          out.then(function () { setTimeout(refresh, 120); }).catch(function () {});
        }
      } catch (e) {}
      return out;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try {
      if (CART_RE.test(String(url))) {
        this.addEventListener('load', function () { setTimeout(refresh, 120); });
      }
    } catch (e) {}
    return _open.apply(this, arguments);
  };

  /* Prestige puts the whole cart in event.detail.cart on cart:change; using
     it skips the /cart.js round trip and cannot race the theme's own state. */
  ['cart:change', 'cart:updated', 'cart:refresh', 'cart:item-added',
   'theme:cart:updated', 'CartUpdated', 'variant:add'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      var c = e && e.detail && (e.detail.cart || e.detail);
      if (c && typeof c.total_price === 'number') apply(c);
      else setTimeout(refresh, 120);
    });
  });

  var busy = false, again = false;
  function refresh() {
    /* Queue rather than drop: Prestige fires cart:change AND completes its
       /cart/change request within milliseconds, and discarding the second
       would leave the bar showing the previous cart. */
    if (busy) { again = true; return; }
    busy = true;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    _fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) apply(c); })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  /* ---------- re-inject after Prestige re-renders the drawer ----------
     The whole reason the bar is injected rather than rendered: the drawer's
     markup is replaced wholesale on every cart change, taking any child with
     it. Coalesced to one check per frame so a burst of mutations costs a
     single query. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      injectDrawer(false);   // no-ops if the bar is already there
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- init ---------- */
  if (cartPageHost) {
    cartPageHost.className = 'asw-db-wrap';
    cartPageHost.setAttribute('role', 'status');
    cartPageHost.setAttribute('aria-live', 'polite');
    cartPageHost.innerHTML = MARKUP;
  }
  injectDrawer(false);
  qualified = paintAll(false);
  /* No popup on init by design: arriving on a page already qualified is not
     the moment of qualifying, and that shopper has already seen it. */
})();
